<template>
  <div class="sdiv dinline-block prelative br2 trans3 cpointer" @click="goRoute(item.id)">
    <div class="ptxt bgw pabsolute pl10 pt30 p100">
      <img class="br50 dinline-block vtop" :src="item.logo" width="100" height="100">
      <div class="txt pl20 pr20 dinline-block tleft vtop">
        <div class="fs18 fbold mb10">{{item.name}}</div>
        <div class="int tc9 lh18 fs12 ofhidden">
          {{item.description}}
        </div>
        <div class="zbtns pabsolute bgw pt20">
          <a href="javascript:;" class="zbtn br30 trans3 fs12 tc9">查看详情</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "w-school-item",
  props: [
    'item',
  ],
  methods:{
    goRoute(id){
      this.$router.push({path:'/dedu/school/detail',query:{id:id}})
    },
  }
}
</script>

<style scoped>
  .sdiv{margin-bottom: 10px;width: 410px;height: 168px;border: 1px solid #f2f2f2;}
  .sdiv:nth-child(3n+2){margin-left: 15px;margin-right: 15px;}
  .sdiv:hover{border-color: #b2792a;}
  .sdiv:hover .ptxt{border-color: #b2792a;}
  .sdiv:hover .zbtn{border-color: #b2792a;color: #b2792a;}
  .ptxt{border: 1px solid transparent;}
  .txt{width: 280px;}
  .zbtn{padding: 3px 13px;border: 1px solid #e1e0e0;}
  .int{height: 40px;}
</style>



// WEBPACK FOOTER //
// src/components/dedu/w-school-item.vue